import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import InstitutionDemoPage from './pages/InstitutionDemoPage';
import CreateBookletFromBankPage from './pages/CreateBookletFromBankPage';
import TeacherBookletsPage from './pages/TeacherBookletsPage';
import LoginPage from './pages/LoginPage';
import RegistrationPage from './pages/RegistrationPage';
import Dashboard from './pages/Dashboard';
import StudentDashboard from './pages/StudentDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import TeacherStudentTracking from './pages/TeacherStudentTracking';
import ParentDashboard from './pages/ParentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminRegistrationDiagnostics from './pages/AdminRegistrationDiagnostics';
import QuestionGenerationAdminPage from './pages/QuestionGenerationAdminPage';
import UserManagementPage from './pages/UserManagementPage';
import FeedbackPage from './pages/FeedbackPage';
import AdminFeedbackPage from './pages/AdminFeedbackPage';
import ChatPage from './pages/ChatPage';
import EvaluatorPage from './pages/EvaluatorPage';
import QuestionGeneratorPage from './pages/QuestionGeneratorPage';
import StudyPlannerPage from './pages/StudyPlannerPage';
import MentorApplicationPage from './pages/MentorApplicationPage';
import QuestionBankPage from './pages/QuestionBankPage';
import TeacherPortalPage from './pages/TeacherPortalEnhanced';
import AdminApprovalPage from './pages/AdminApprovalPage';
import AdminMentorApplicationsPage from './pages/AdminMentorApplicationsPage';
import BulkUploadPage from './pages/BulkUploadPage';
import DigitalLibraryPage from './pages/DigitalLibraryPage';
import PersonalizedLearningPage from './pages/PersonalizedLearningPage';
import MyLearningJourney from './pages/MyLearningJourney';
import MyStudyPlan from './pages/MyStudyPlan';
import MyTasks from './pages/MyTasks';
import DetailedWeeklyPlanPage from './pages/DetailedWeeklyPlanPage';
import InstitutionManagementPage from './pages/InstitutionManagementPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import PlatformAnalyticsPage from './pages/PlatformAnalyticsPage';
import BookletDesignerPage from './pages/BookletDesignerPage';
import BookletViewPage from './pages/BookletViewPage';
import BookletTakePage from './pages/BookletTakePage';
import BookletResultsPage from './pages/BookletResultsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { ModeProvider } from './contexts/ModeContext';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ModeProvider>
          <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/institution-demo" element={<InstitutionDemoPage />} />
              <Route path="/create-booklet-from-bank" element={
                <ProtectedRoute>
                  <CreateBookletFromBankPage />
                </ProtectedRoute>
              } />
              <Route path="/teacher/my-booklets" element={
                <ProtectedRoute>
                  <TeacherBookletsPage />
                </ProtectedRoute>
              } />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegistrationPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/mentor/apply" element={<MentorApplicationPage />} />
              
              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <StudentDashboard />
                </ProtectedRoute>
              } />
              <Route path="/student/dashboard" element={
                <ProtectedRoute>
                  <StudentDashboard />
                </ProtectedRoute>
              } />
              <Route path="/teacher/dashboard" element={
                <ProtectedRoute>
                  <TeacherDashboard />
                </ProtectedRoute>
              } />
              <Route path="/teacher/students" element={
                <ProtectedRoute>
                  <TeacherStudentTracking />
                </ProtectedRoute>
              } />
              <Route path="/parent/dashboard" element={
                <ProtectedRoute>
                  <ParentDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute>
                  <UserManagementPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/settings" element={
                <ProtectedRoute>
                  <AdminSettingsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/question-generation" element={
                <ProtectedRoute>
                  <QuestionGenerationAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/registration-diagnostics" element={
                <ProtectedRoute>
                  <AdminRegistrationDiagnostics />
                </ProtectedRoute>
              } />
              <Route path="/admin/feedback" element={
                <ProtectedRoute>
                  <AdminFeedbackPage />
                </ProtectedRoute>
              } />
              <Route path="/feedback" element={
                <ProtectedRoute>
                  <FeedbackPage />
                </ProtectedRoute>
              } />
              <Route path="/chat/:mentorType" element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              } />
              <Route path="/evaluator" element={
                <ProtectedRoute>
                  <EvaluatorPage />
                </ProtectedRoute>
              } />
              <Route path="/questions" element={
                <ProtectedRoute>
                  <QuestionGeneratorPage />
                </ProtectedRoute>
              } />
              <Route path="/study-plan" element={
                <ProtectedRoute>
                  <StudyPlannerPage />
                </ProtectedRoute>
              } />
              <Route path="/question-bank" element={
                <ProtectedRoute>
                  <QuestionBankPage />
                </ProtectedRoute>
              } />
              <Route path="/teacher-portal" element={
                <ProtectedRoute>
                  <TeacherPortalPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/approval" element={
                <ProtectedRoute>
                  <AdminApprovalPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/applications" element={
                <ProtectedRoute>
                  <AdminMentorApplicationsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/bulk-upload" element={
                <ProtectedRoute>
                  <BulkUploadPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/library" element={
                <ProtectedRoute>
                  <DigitalLibraryPage />
                </ProtectedRoute>
              } />
              <Route path="/personalized-learning" element={
                <ProtectedRoute>
                  <PersonalizedLearningPage />
                </ProtectedRoute>
              } />
              <Route path="/my-learning-journey" element={
                <ProtectedRoute>
                  <MyLearningJourney />
                </ProtectedRoute>
              } />
              <Route path="/my-plan" element={
                <ProtectedRoute>
                  <MyStudyPlan />
                </ProtectedRoute>
              } />
              <Route path="/my-tasks" element={
                <ProtectedRoute>
                  <MyTasks />
                </ProtectedRoute>
              } />
              <Route path="/premium/detailed-plan" element={
                <ProtectedRoute>
                  <DetailedWeeklyPlanPage />
                </ProtectedRoute>
              } />
              <Route path="/institution/management" element={
                <ProtectedRoute>
                  <InstitutionManagementPage />
                </ProtectedRoute>
              } />
              <Route path="/payment/success" element={
                <ProtectedRoute>
                  <PaymentSuccessPage />
                </ProtectedRoute>
              } />
              <Route path="/payment/cancel" element={
                <ProtectedRoute>
                  <PaymentCancelPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/analytics" element={
                <ProtectedRoute>
                  <PlatformAnalyticsPage />
                </ProtectedRoute>
              } />
              <Route path="/booklet-designer" element={
                <ProtectedRoute>
                  <BookletDesignerPage />
                </ProtectedRoute>
              } />
              <Route path="/booklets/:bookletId" element={
                <ProtectedRoute>
                  <BookletViewPage />
                </ProtectedRoute>
              } />
              <Route path="/booklet/:bookletId/take" element={
                <ProtectedRoute>
                  <BookletTakePage />
                </ProtectedRoute>
              } />
              <Route path="/practice/:taskId" element={
                <ProtectedRoute>
                  <BookletTakePage isPractice={true} />
                </ProtectedRoute>
              } />
              <Route path="/booklet/:bookletId/results/:submissionId" element={
                <ProtectedRoute>
                  <BookletResultsPage />
                </ProtectedRoute>
              } />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
        </ModeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;